<template>
  <li class="integration-card" :class="{ 'opacity-50 pointer-events-none': !integration.enabled && !isOrgUserAdmin }">
    <div class="integration-icon">
      <img :src="integration.icon" width="24" height="24" />
    </div>
    <div class="flex-grow">
      <h2 class="integration-name">{{ integration.name }}</h2>
      <p class="integration-description">{{ integration.description }}</p>

      <div v-if="isOrgUserAdmin" class="integration-button">
        <IntegrationButton :integration="integration" @toggle="handleToggle" @request-enable="handleRequestEnable" />
      </div>
      <div v-else class="integration-button">
        <IntegrationStatus :integration="integration" />
      </div>
    </div>
  </li>
</template>

<script setup lang="ts">
import { Integration } from '@/modules/integrations/store/useIntegrationStore';
import { useUserStore } from '@/store/useUserStore';
import { storeToRefs } from 'pinia';
import IntegrationButton from '../ui/IntegrationButton.vue';
import IntegrationStatus from '../ui/IntegrationStatus.vue';

interface Props {
  integration: Integration;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  toggle: [name: string];
  requestEnable: [name: string];
}>();

const userStore = useUserStore();
const { isOrgUserAdmin } = storeToRefs(userStore);

const handleToggle = () => {
  emit('toggle', props.integration.name);
};

const handleRequestEnable = (name: string) => {
  emit('requestEnable', name);
};
</script>

<style scoped>
.integration-card {
  @apply flex items-start gap-6 p-8 bg-white dark:bg-zinc-800 rounded-10 border border-slate-300 dark:border-zinc-700;
}
.integration-icon {
  @apply w-14 h-14 flex items-center justify-center p-4 rounded-full bg-white border border-slate-300 dark:border-zinc-700;
}
.integration-name {
  @apply text-xl font-semibold text-slate-900 dark:text-zinc-300;
}
.integration-description {
  @apply text-sm text-slate-700 dark:text-zinc-400;
}
.integration-button {
  @apply mt-4;
}
</style>
